// extracted by mini-css-extract-plugin
export default {"image":"e1-z","loaded":"f1-z"};